<div class="col itemsContainer d-print-block-visible" [ngClass]="getClasses()">
    <div class="row report-controls">
        <div class="col-2" *ngIf="showCommandButtons()">
            <input class="btn btn-primary" type="button" (click)="goBack()" value="Back" />
        </div>
        <div [ngClass]="{'col-8': showCommandButtons(), 'col-12 text-center': !showCommandButtons()}">
            <h1 class="h1-responsive report-name text-center">{{ReportName}}</h1>
        </div>
        <div class="col-2 ml-auto" *ngIf="showCommandButtons()">
            <input class="btn btn-secondary" type="button" (click)="print()" value="Download PDF" />
        </div>
    </div>
    <div class="row" *ngIf="!hasLoadedResults">
        <div class="col" >
            <p class="alert alert-warning">
                <app-spin-icon></app-spin-icon> Loading Report data...</p>
        </div>
    </div>
    <div class="row d-print-block-visible">
        <div class="col d-print-block-visible">
            <!-- note all the report items are placed as siblings to #container -->
            <div class="containerReference" #container></div>
        </div>
    </div>
</div>
<dac-print-dialog [isOpen]="showPrintDialog" (close)="closePrintDialog()" [assignment]="assignment"></dac-print-dialog>


// WEBPACK FOOTER //
// ./src/app/reports/report-viewer/report-viewer.component.html